import { render, staticRenderFns } from "./settings-page.vue?vue&type=template&id=57d32572"
import script from "./settings-page.vue?vue&type=script&lang=js"
export * from "./settings-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57d32572')) {
      api.createRecord('57d32572', component.options)
    } else {
      api.reload('57d32572', component.options)
    }
    module.hot.accept("./settings-page.vue?vue&type=template&id=57d32572", function () {
      api.rerender('57d32572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/settings-page.vue"
export default component.exports